import { useFormContext, useWatch } from 'react-hook-form';
import {
  BLOCK_TYPE_LABELS,
  type LandingPageBlockType,
  type LandingPageFormValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

const UNTITLED = 'Untitled block';

export const useBlockTitle = (index: number, type: LandingPageBlockType): string => {
  const { control } = useFormContext<LandingPageFormValues>();
  const contentTitle = useWatch({ control, name: `blocks.${index}.contentTitle` });

  if (type !== 'content') {
    return BLOCK_TYPE_LABELS[type];
  }

  return String(contentTitle ?? '').trim() || UNTITLED;
};
